import { Link } from 'react-router-dom'
import { useT } from '../../lib/i18n'
import ArabesqueBorder from '../ornaments/ArabesqueBorder'

export default function Footer() {
  const t = useT()

  return (
    <footer className="bg-[var(--color-indigo-900)] text-[var(--color-ink-muted)]">
      <div className="container-x py-6">
        <ArabesqueBorder />
      </div>

      <div className="container-x grid grid-cols-1 md:grid-cols-3 gap-10 py-12">
        <div>
          <div className="flex items-center mb-4">
            <img
              src="/logos/agentlik.png"
              alt="Ixtisoslashtirilgan taʼlim muassasalari agentligi"
              className="h-14 w-auto"
            />
          </div>
          <p className="text-sm leading-relaxed">{t('brand.full')}</p>
        </div>

        <div>
          <h3 className="font-semibold text-white mb-4 tracking-wide text-sm uppercase">
            Sahifalar
          </h3>
          <nav className="flex flex-col gap-2 text-sm">
            <Link to="/" className="hover:text-white transition-colors">{t('nav.home')}</Link>
            <Link to="/tanlov-tartibi" className="hover:text-white transition-colors">{t('nav.tartib')}</Link>
            <Link to="/nizom" className="hover:text-white transition-colors">{t('nav.nizom')}</Link>
            <Link to="/murojaat" className="hover:text-white transition-colors">{t('nav.murojaat')}</Link>
          </nav>
        </div>

        <div>
          <h3 className="font-semibold text-white mb-4 tracking-wide text-sm uppercase">
            Bogʻlanish
          </h3>
          <p className="text-sm">
            <a href="mailto:info@piima.uz" className="hover:text-white transition-colors">
              info@piima.uz
            </a>
          </p>
          <p className="text-sm mt-1 font-medium tracking-wider">{t('footer.domain')}</p>
        </div>
      </div>

      <div className="container-x py-5 border-t border-white/[0.08] text-xs text-center text-[var(--color-ink-subtle)]">
        {t('footer.rights')}
      </div>
    </footer>
  )
}
